<div class="container pzu-banner">
  <div class="pzu-banner__advert">{{ 'PZU_BANNER.advertisement' | translate }}</div>

  <div class="pzu-banner__content">
    <div class="pzu-banner__content__left">
      <div class="pzu-banner__content__logo-link">
        <img class="pzu-banner__content__logo" (click)="visitPZUWebsite()" [src]="logoUrl" alt="PZU">
      </div>
      <div class="pzu-banner__content__text">
        <div class="pzu-banner__link pzu-banner__content__title" [innerHTML]="'PZU_BANNER.title' | translate | safeHtml" (click)="visitPZUWebsite()"></div>
        <div class="pzu-banner__link pzu-banner__content__subtitle" [innerHTML]="'PZU_BANNER.subtitle' | translate | safeHtml" (click)="visitPZUWebsite()"></div>
      </div>
    </div>
    <div class="pzu-banner__content__actions offer__action">
      <button class="btn btn--secondary btn--small-padding buy-online"
              (click)="visitPZUWebsite()">
        {{'PZU_BANNER.checkPrice' | translate}}
      </button>
      <button class="btn btn--clear offer__action__order-call-btn" (click)="orderCall()"> {{ 'OFFER_SECTION.SHARED.orderCall' | translate }} </button>
    </div>
  </div>
</div>
